export default __webpack_public_path__ + "static/media/icon-close.dd8f15ca.svg";